import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'

import { Appointments } from '../pages/legacy/appointments'
import { Audits } from '../pages/legacy/audits'
import { Auth } from '../pages/legacy/auth'
import { CheckIn } from '../pages/legacy/check-in'
import { CheckinHistory } from '../pages/legacy/check-in-history'
import { GateFeed } from '../pages/gate-feed'
import { GateFeed as GateFeedLegacy } from '../pages/legacy/gate-feed'
import { Reports } from '../pages/legacy/reports'
import { Settings } from '../pages/legacy/settings'
import { ISR2305Report } from '../pages/reports/isr2305'
import { ISR } from '../pages/isr'
import { YardInventory } from '../pages/yard-inventory'
import { Analytics } from '../pages/analytics'

export function Router(): JSX.Element {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<Navigate to="/gate-feed" />} />
        <Route path="/auth" element={<Auth />} />,
        <Route index path="/gate-feed" element={<GateFeed />} />
        <Route index path="/gate-feed-legacy" element={<GateFeedLegacy />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/check-in" element={<CheckIn />} />
        <Route path="/check-in-history" element={<CheckinHistory />} />
        <Route path="/reports/isr2305" element={<ISR />} />
        <Route path="/reports/isr-legacy" element={<ISR2305Report />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/audits" element={<Audits />} />
        <Route path="/yard-inventory" element={<YardInventory />} />
        <Route path="/analytics" element={<Analytics />} />
      </Route>
    )
  )

  return <RouterProvider router={router} />
}
